var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"StatusSection"},[_c('Section',{staticClass:"StatusSection__section"},[_c('Headline',{class:[
        'StatusSection__section-headline',
        'StatusSection__section-headline_centered'
      ],attrs:{"size":3}},[_vm._v(_vm._s(_vm.message)+" ")]),_c('div',{staticClass:"StatusSection__section-check-container"},[_c('img',{staticClass:"StatusSection__section-check",attrs:{"src":_vm.$static.icons.check,"alt":""}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }